import { render, staticRenderFns } from "./EditProjectModal.vue?vue&type=template&id=0f42a2e8&scoped=true"
import script from "./EditProjectModal.vue?vue&type=script&lang=js"
export * from "./EditProjectModal.vue?vue&type=script&lang=js"
import style0 from "./EditProjectModal.vue?vue&type=style&index=0&id=0f42a2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42a2e8",
  null
  
)

export default component.exports